export default function({ route, from, to, store, redirect }) {
    window.scrollTo(0, 0);
}